const CHAVE_CADASTRO_CONCLUIDO_NA_SESSAO = 'biometria:cadastro-concluido-na-sessao'

const obterSessionStorage = (): Storage | null => {
  try {
    return window?.sessionStorage ?? null
  } catch {
    return null
  }
}

const possuiCadastroConcluidoNaSessao = (): boolean => {
  return obterSessionStorage()?.getItem(CHAVE_CADASTRO_CONCLUIDO_NA_SESSAO) === 'true'
}

const registrarCadastroConcluidoNaSessao = (): void => {
  obterSessionStorage()?.setItem(CHAVE_CADASTRO_CONCLUIDO_NA_SESSAO, 'true')
}

const resetarSessaoCadastroBiometria = (): void => {
  obterSessionStorage()?.removeItem(CHAVE_CADASTRO_CONCLUIDO_NA_SESSAO)
}

export const useSessaoCadastroBiometria = () => {
  return {
    possuiCadastroConcluidoNaSessao,
    registrarCadastroConcluidoNaSessao,
    resetarSessaoCadastroBiometria,
  }
}
